export default {
  'smsMessageTrace.title': 'SMS Message Traces',
};
